<template>
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="1.06066" y1="1" x2="6" y2="5.93934" stroke="#6B7E99" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="0.75" y1="-0.75" x2="7.73528" y2="-0.75" transform="matrix(-0.707107 0.707107 0.707107 0.707107 12 1)" stroke="#6B7E99" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
        name:"Arrow"
    }
</script>